export const MESSAGING_ARCHIVED_VIEW = 'archived';
